function validation(paint) {
    let errors = {}

    // title
    if (!paint.title) {
        errors.title = 'تیتر را وارد نکردید.'
    } else if (!paint.title.trim()) {
        errors.title = 'تیتر را وارد نکردید.'
    } else if (paint.title.length > 90) {
        errors.title = 'طول تیتر نباید بیشتر از 90 کارکتر باشد.'
    } else {
        delete errors.title
    }
    // artist
    if (!paint.artist_id) {
        errors.artist_id = 'لطفا هنرمند را وارد کنید.'
    } else {
        delete errors.artist_id
    }
    // images
    if (!paint._method && !paint.images.length) {
        errors.images = 'لطفا عکس اصلی را وارد کنید.'
    } else {
        delete errors.images
    }
    // width_pixel
    if (!paint.width_pixel) {
        errors.width_pixel = "الزامی"
    } else {
        delete errors.width_pixel
    }
    // height_pixel
    if (!paint.height_pixel) {
        errors.height_pixel = "الزامی"
    } else {
        delete errors.height_pixel
    }
    // min_width
    if (!paint.min_width) {
        errors.min_width = "الزامی"
    } else if (paint.min_width < 15) {
        errors.min_width = "نباید کمتر از 15 باشد"
    } else {
        delete errors.min_width
    }
    // min_height
    if (!paint.min_height) {
        errors.min_height = "الزامی"
    } else if (paint.min_height < 15) {
        errors.min_height = "نباید کمتر از 15 باشد"
    } else {
        delete errors.min_height
    }
    // max_width
    if (!paint.max_width) {
        errors.max_width = "الزامی"
    } else if (paint.max_width > 115) {
        errors.max_width = "نباید بیشتر از 115 باشد"
    } else {
        delete errors.max_width
    }
    // max_height
    if (!paint.max_height) {
        errors.max_height = "الزامی"
    } else if (paint.max_height > 115) {
        errors.max_height = "نباید بیشتر از 115 باشد"
    } else {
        delete errors.max_height
    }

    return errors
}
export default validation;